<template>
  <div class = "modal">
    <div class = "modal-background"></div>
    <div class = "modal-card">
      <header class = "modal-card-head">
        <div class = "content">hello</div>
      </header>
      <div class = "modal-card-body">
        <div class = "content">hello</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailCube',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
@import "../../node_modules/bulma/bulma.sass"
@media screen and (max-width: 768px)
  .is-not-mobile
    display: none
  .is-mobile
    display: block

@media screen and (min-width: 769px)
  .is-not-mobile
    display: inherit
  .is-mobile
    display: none

.modal-card
  border-radius: 5px

.modal
  z-index: 999

.fade-enter-active
  animation: show .4s 1

.fade-leave-active
  animation: show .4s reverse

@keyframes show
  0%
    opacity: 0.3
    transform: translateY(-5px)
  100%
    opacity: 1
    transform: translateY(0px)

</style>



// WEBPACK FOOTER //
// src/components/DetailCube.vue